(function() {
  'use strict';

  angular.module('app').controller('EVSController', EVSController);

  EVSController.$inject = [
    '$scope',
    '$rootScope',
    '$routeParams',
    'LoyaltyService',
    '$location',
    'LANGS',
    '$filter',
    '$timeout',
    '$q',
    '$uibModal',
    'blockUI',
    'SelectService',
    'NotifyService',
    'MessageService',
    'TransactionService',
    'POSService',
    'BusinessService',
    'SettingsService',
    'EVSService'];

  function EVSController($scope, $rootScope, $routeParams, LoyaltyService, $location, LANGS, $filter, $timeout,
      $q, $uibModal, blockUI,
      SelectService, NotifyService, MessageService, TransactionService, POSService, BusinessService,
      SettingsService, EVSService) {
    $scope.getLoyaltiesList = SelectService.getLoyaltiesList;

    $scope.getPages = getTotalPaginatedPages;
    $scope.isPhoneValid = isPhoneValid;

    $scope.params = {
      page: 1,
      count: 10,
      date_from: moment().subtract(1, 'month').utc().toDate(),
      date_to: moment().endOf('day').utc().toDate(),
      time_from: moment().startOf('day').utc().toDate(),
      time_to: moment().endOf('day').utc().toDate(),
      order: 'desc',
      sort: 'processed'
    };
    $scope.customerValues = {
      email: '',
      phone: '',
      'external-id': ''
    };
    $scope.customerTypes = [
      {
        title: 'Customer email',
        value: 'email'
      },
      {
        title: 'Customer phone',
        value: 'phone'
      }
    ];

    $scope.table_columns = [
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'user_phone', text: 'Customer number', visible: true},
          {value: 'user_email', text: 'Customer email', visible: true},
          {value: 'user_name', text: 'Username', visible: true},
          {
            value: 'user_external_id',
            text: 'Customer external id',
            visible: false,
            not_sortable: true
          }
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'verified_object', text: 'EVS verified object', visible: true},
          {value: 'verify_code', text: 'EVS verified code', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'billing_amount', text: 'EVS billing amount', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'src_type', text: 'EVS src_type', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'processed', text: 'EVS Processed', visible: true}
        ]
      }
    ];

    $scope.data = {
      pagerLengths: [10, 20, 50, 100, 200],
      evsList: null,
      summary: {},
      currentCustomerLoginType: angular.copy($scope.customerTypes[0])
    };

    $scope.isSupportUserExternalId = false;

    var block_evs_list = blockUI.instances.get('evs_list');

    SettingsService.GetPlatformParams(function(success, response) {
      if (success) {
        $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

        if ($scope.isSupportUserExternalId) {
          $scope.customerTypes.push({
            title: 'Customer external id',
            value: 'external-id'
          });

          $scope.table_columns.forEach(function(column) {
            column.data.forEach(function(item) {
              if (item.value === 'user_external_id') {
                item.visible = true;
              }
            });
          });
        }

      }

      initController();
    });

    function initController() {
      getEVS();
    }

    function getEVS() {
      block_evs_list.start();
      var params = angular.copy($scope.params);

      if (params.date_from && params.time_from) {
        params.date_from = moment(params.date_from).set({
          hour: moment(params.time_from).get('hour'),
          minute: moment(params.time_from).get('minute'),
          second: moment(params.time_from).get('second')
        });
        delete params.time_from;
      }
      if (params.date_to && params.time_to) {
        params.date_to = moment(params.date_to).set({
          hour: moment(params.time_to).get('hour'),
          minute: moment(params.time_to).get('minute'),
          second: moment(params.time_to).get('second')
        });
        delete params.time_to;
      }

      if ($scope.data.currentCustomerLoginType && $scope.customerValues[$scope.data.currentCustomerLoginType.value]) {
        params.user_id_value = $scope.customerValues[$scope.data.currentCustomerLoginType.value];
        params.user_id_type = $scope.data.currentCustomerLoginType.value;
      }

      if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id && $scope.data.currentLoyalty.id !== '0') {
        params.loyalty_id = $scope.data.currentLoyalty.id;
      }

      params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);
      params = cleanRequestData(params);
      EVSService.getUsage(params, function(success, response) {
        if (success) {
          $scope.data.evsList = response.data;
          $scope.data.summary = response.summary;
        }

        block_evs_list.stop();
      });
    }

    $scope.getEVS = function() {
      getEVS();
    };

    $scope.pageChange = function() {
      getEVS();
    };

    $scope.onCountChange = function(count) {
      $scope.params.page = 1;
      $scope.params.count = count;
      getEVS();
    };

    $scope.getTableHeaderClass = function(row) {
      return {
        'sorting_asc': !!($scope.params.sort == row.value && $scope.params.order == 'asc'),
        'sorting_desc': !!($scope.params.sort == row.value && $scope.params.order == 'desc'),
        'sorting': !row.not_sortable
      };
    };
    $scope.onSortOrderChange = function(row) {
      if (!!row.not_sortable) {
        return;
      }
      var field = row.value;
      if ($scope.params.sort === field)
        $scope.params.order = $scope.params.order == 'asc' ? 'desc' : 'asc';

      $scope.params.sort = field;

      getEVS();
    };
    $rootScope.$watch('LOYALTIES', function(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);
        $scope.data.loyaltiesList.unshift({title: $filter('translate')('All loyalties'), id: '0', active: 1});

        var saved_loyalty;

        if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
          $scope.data.currentLoyalty = $scope.data.loyaltiesList.find(function(filterItem) {
            if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
              return true;
            }
          });
        } else {
          var index;

          for (var i in $scope.data.loyaltiesList)
            if ($scope.data.loyaltiesList[i].id === '0')
              $scope.data.currentLoyalty = $scope.data.loyaltiesList[i];
        }
      }
    });
    $scope.$watch('data.currentLoyalty', function(newValue, oldValue) {
      if (newValue) {
        getEVS();

        // $rootScope.ENV.filters.messages_list = {
        //   loyalty_id: newValue.id
        // };
        $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
        $rootScope.storeENV();
      }
    }, true);
  }
})();
